import React, { useState } from 'react';
import { AppBar, Box, Button, IconButton, Menu, MenuItem, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import BrandLogo from './BrandLogo';

const PublicNavbar: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleNavigate = (path: string) => {
    setAnchorEl(null);
    navigate(path);
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: '#fdf3e4',
        borderBottom: '1px solid #eeddc7',
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 64, sm: 72 }, justifyContent: 'space-between', px: { xs: 1.25, sm: 2, md: 4 }, gap: 1, overflow: 'hidden' }}>
        <Box sx={{ minWidth: 0, flex: 1, display: 'flex', alignItems: 'center' }}>
          <BrandLogo to="/" logoHeight={isMobile ? 32 : 42} showText textColor="#7b0011" />
        </Box>

        {isMobile ? (
          <>
            <IconButton aria-label="Open navigation menu" title="Open navigation menu" onClick={(event) => setAnchorEl(event.currentTarget)} sx={{ color: '#7b0011', flex: '0 0 auto' }}>
              <MenuIcon />
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
              <MenuItem onClick={() => handleNavigate('/about-us')}>About Us</MenuItem>
              <MenuItem onClick={() => handleNavigate('/contact')}>Contact</MenuItem>
              <MenuItem onClick={() => handleNavigate('/login')}>Login</MenuItem>
              <MenuItem onClick={() => handleNavigate('/register')} sx={{ color: '#7b0011', fontWeight: 800 }}>Register</MenuItem>
            </Menu>
          </>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: '0 0 auto' }}>
            <Button variant="text" onClick={() => navigate('/about-us')} sx={{ color: '#7b0011', textTransform: 'none', fontWeight: 700 }}>About Us</Button>
            <Button variant="text" onClick={() => navigate('/contact')} sx={{ color: '#7b0011', textTransform: 'none', fontWeight: 700 }}>Contact</Button>
            <Button variant="text" onClick={() => navigate('/login')} sx={{ fontFamily: "'Georgia', 'Times New Roman', serif", color: '#7b0011', textTransform: 'none', fontWeight: 700, fontSize: '0.95rem' }}>Login</Button>
            <Button variant="contained" onClick={() => navigate('/register')} sx={{ fontFamily: "'Georgia', 'Times New Roman', serif", textTransform: 'none', fontWeight: 700, fontSize: '0.95rem', borderRadius: '10px', px: 2.5, backgroundColor: '#7b0011', boxShadow: '0 4px 14px rgba(123, 0, 17, 0.3)', '&:hover': { backgroundColor: '#5d000d' } }}>Register</Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default PublicNavbar;
